
import axios from 'axios';
import { ENDPOINT } from '../endpoint';

export const getSettingsApi = (payload: any) => {
    return axios.post(`${ENDPOINT.SETTINGS}`, payload);
}

export const saveVoteApi = (payload: any)=>{
    return axios.post(`${ENDPOINT.SAVE_VOTE}`, payload);
}

export const getVoteApi = (payload: any)=>{
    return axios.post(`${ENDPOINT.GET_VOTE}`, payload);
}

export const sendEmailApi = (payload: any)=>{
    return axios.post(`${ENDPOINT.SEND_EMAIL}`, payload);
}

export const uploadImageApi  = (payload: any)=>{
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    return axios.post(`${ENDPOINT.UPLOAD_IMAGE}`, payload, config);
}